@if (showMoveAssigneeModal) {
<app-dialog-title>
  {{ "move" | transloco }} {{ taxpayerAlias }}s
</app-dialog-title>
<mat-dialog-content class="content">
  @if (bulkActionState !== 'COMPLETED') {
  <div>
    @if (selectedTaxReturnIds.length<=0) {
    <p>
      {{ 'there-is-no-taxpayer-alias-selected' | transloco: {taxpayerAlias} }}
    </p>
    } @if (selectedTaxReturnIds.length>0) {
    <div>
      <p>
        Are you sure you want to move the selected
        {{ selectedTaxReturnIds.length }} {{ taxpayerAlias }}s to another
        population?
      </p>
      @if (errorMessage) {
      <p class="error-message">{{ errorMessage }}</p>
      } @if (showClientOption) {
      <div>
        <label>{{ "select-client" | transloco }}</label>
        <select
          class=" ui selection dropdown form-control small"
          [(ngModel)]="clientId"
          (ngModelChange)="changeClient(clientId)"
        >
          <option value="">{{ "select-a-client" | transloco }}</option>
          @for (client of clientList; track client) {
          <option [value]="client.id">
            {{ client.name }}
          </option>
          }
        </select>
      </div>
      }
      <div>
        <label>{{ "select-population" | transloco }}</label>
        <select
          [(ngModel)]="populationId"
          class=" ui selection dropdown form-control small"
        >
          <option value="">{{ "select-a-population" | transloco }}</option>
          @for (pop of populationList; track pop) {
          <option [value]="pop.id">
            {{ pop.name }}
          </option>
          }
        </select>
      </div>
    </div>
    }
  </div>
  } @if (bulkActionState === 'COMPLETED') {
  <div>
    @for (item of responseData; track item) {
    <div>
      @if (item.success) {
      <p>
        <i class="green check icon"></i>
        <strong
          >{{ selectedTaxReturns[item.taxreturnId].firstName }}
          {{ selectedTaxReturns[item.taxreturnId].lastName }} #{{
            item.taxreturnId
          }}</strong
        >: Success.
      </p>
      } @if (!item.success) {
      <p>
        <i class="red x icon"></i>
        <strong
          >{{ selectedTaxReturns[item.taxreturnId].firstName }}
          {{ selectedTaxReturns[item.taxreturnId].lastName }} #{{
            item.taxreturnId
          }}</strong
        >:
        {{ item.errorMessage || "Failed to update status." }}
      </p>
      }
    </div>
    }
  </div>
  }
</mat-dialog-content>
@if (bulkActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="moveAssignees()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: bulkActionState === 'LOADING' }"
  >
    {{ "move" | transloco }} {{ taxpayerAlias }}s
  </button>
</mat-dialog-actions>
} @if (bulkActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
